module.exports = __webpack_public_path__ + "static/media/sf-logo.4399027f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sf-logo.png
// module id = 615
// module chunks = 0